// extracted by mini-css-extract-plugin
export default {"tx":"ee8eacf100","line":"_74243c4491"};